var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container flex"},[_c('div',[_c('h1',[_vm._v("Page not found!")]),_c('router-link',{attrs:{"to":"/"}},[_c('v-btn',{attrs:{"color":"primary"}},[_vm._v(" Go Home ")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }